import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCondoNavItems } from '../lib/condoNavItems';
import { useBottomNavTarget } from '../lib/useBottomNavTarget';

// Six sections fit; with more, the sixth slot becomes "More" (context/MobileNavigation.md).
const MAX_TABS = 6;

const MORE_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

function BottomNav() {
  const navigate = useNavigate();
  const { slug: condoSlug, currentTab } = useBottomNavTarget();
  const navItems = useCondoNavItems(condoSlug);
  const [moreOpen, setMoreOpen] = useState(false);

  if (!condoSlug) return null;

  const overflow = navItems.length > MAX_TABS;
  const tabs = overflow ? navItems.slice(0, MAX_TABS - 1) : navItems;
  const more = overflow ? navItems.slice(MAX_TABS - 1) : [];
  const moreActive = more.some((item) => item.key === currentTab);

  const go = (item) => {
    setMoreOpen(false);
    navigate(`/${condoSlug}${item.path}`);
  };

  const tabClass = (active) => `flex-1 min-w-0 flex flex-col items-center justify-center gap-1 py-2.5 font-medium transition-colors ${
    active ? 'text-primary bg-primary/10' : 'text-muted-foreground'
  }`;

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-card border-t border-border pb-[env(safe-area-inset-bottom)]">
      {moreOpen && (
        <div role="menu" aria-label="More sections" className="absolute bottom-full right-0 mb-2 mr-2 w-48 bg-card border border-border rounded-lg shadow-lg py-1">
          {more.map((item) => (
            <button
              key={item.key}
              role="menuitem"
              onClick={() => go(item)}
              className={`flex items-center gap-3 w-full px-4 py-2.5 text-sm ${item.key === currentTab ? 'text-primary' : 'text-foreground'} hover:bg-muted`}
            >
              {item.icon}
              {item.label}
            </button>
          ))}
        </div>
      )}
      <div className="flex">
        {tabs.map((item) => (
          <button key={item.key} onClick={() => go(item)} className={tabClass(currentTab === item.key)}>
            {item.icon}
            <span className="w-full truncate text-center text-xxs">{item.label}</span>
          </button>
        ))}
        {overflow && (
          <button aria-expanded={moreOpen} onClick={() => setMoreOpen(!moreOpen)} className={tabClass(moreActive)}>
            {MORE_ICON}
            <span className="w-full truncate text-center text-xxs">More</span>
          </button>
        )}
      </div>
    </nav>
  );
}

export default BottomNav;
